// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"c463afd1","836":"ebdbf67e"}[chunkId] + ".chunk.css";
};